import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this._onKeydown = (e) => {
      if (e.key === "Escape") this.close()
    }
  }

  disconnect() {
    this._removeKeydown()
    this._unlockScroll()
  }

  toggle() {
    if (this._isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.backdropTarget.classList.remove("hidden")
    this._lockScroll()
    this._addKeydown()
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.backdropTarget.classList.add("hidden")
    this._unlockScroll()
    this._removeKeydown()
  }

  toggleSection(event) {
    const button = event.currentTarget
    const wrapper = button.closest("li")
    const submenu = wrapper?.querySelector("[data-student-menu-submenu]")
    if (!submenu) return

    const chevron = button.querySelector("[data-student-menu-chevron]")
    const willOpen = submenu.classList.contains("max-h-0")

    submenu.classList.toggle("max-h-0", !willOpen)
    submenu.classList.toggle("opacity-0", !willOpen)
    submenu.classList.toggle("pointer-events-none", !willOpen)
    submenu.classList.toggle("max-h-96", willOpen)
    submenu.classList.toggle("opacity-100", willOpen)
    submenu.classList.toggle("pointer-events-auto", willOpen)
    chevron?.classList.toggle("rotate-180", willOpen)
    button.setAttribute("aria-expanded", String(willOpen))
  }

  _isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }

  _lockScroll() {
    document.body.classList.add("overflow-hidden")
  }

  _unlockScroll() {
    document.body.classList.remove("overflow-hidden")
  }

  _addKeydown() {
    window.addEventListener("keydown", this._onKeydown)
  }

  _removeKeydown() {
    window.removeEventListener("keydown", this._onKeydown)
  }
}
